import type {
  CoraPublicSettings,
  CoraTicketRequest,
  CoraTurnRequest,
  CoraTurnResponse,
} from "@/interfaces/cora";
import { apiClient } from "@/lib/apiClient";

/** Cora's UI copy and per-screen opening questions. */
export async function fetchCoraSettings(): Promise<CoraPublicSettings> {
  const { data } = await apiClient.get<{ success: boolean; settings: CoraPublicSettings }>(
    "/cora/settings",
  );
  return data.settings;
}

/** One Cora chat turn: the user's message plus recent history in, Cora's outcome out. */
export async function postCoraTurn(body: CoraTurnRequest): Promise<CoraTurnResponse> {
  const { data } = await apiClient.post<{ success: boolean; turn: CoraTurnResponse }>(
    "/cora/turn",
    body,
  );
  return data.turn;
}

/** Files the details form as a support ticket: JSON `payload` part plus an optional `screenshot`. */
export async function postCoraTicket(input: CoraTicketRequest): Promise<{ filed: boolean }> {
  const { screenshot, ...payload } = input;
  const form = new FormData();
  form.append("payload", JSON.stringify(payload));
  if (screenshot) form.append("screenshot", screenshot);
  const { data } = await apiClient.post<{ success: boolean; filed: boolean }>("/cora/ticket", form);
  return { filed: data.filed };
}
